angular.module('cfn').filter('convertUnit', [
  'unitConverter',
  function(unitConverter) {
    /**
     * Converts units using the unitConverterService.
     * @param {number} value value to be converted (if it's not a number it will be returned as is)
     * @param {(string|function)} unitFrom unit to convert from as defined in enums (e.g. 'AREAL_HA')
     * @param {(string|function)} unitTo unit to convert to as defined in enums
     */
    return function(value, unitFrom, unitTo) {
      if (_.isNumber(value)) {
        var from = _.isFunction(unitFrom) ? unitFrom() : unitFrom;
        var to = _.isFunction(unitTo) ? unitTo() : unitTo;
        return unitConverter.convert(from, to, value);
      }

      return value;
    };
  }
]);
